import { ApprovalsResultEntity } from "../entities/ApprovalEntity";
import {
  ApprovalRepository,
  GetApprovalsParams,
} from "../repositories/ApprovalRepository";

/**
 * Get Approvals Use Case
 * Fetches paginated approvals with optional filters
 */
export class GetApprovalsUseCase {
  constructor(private repository: ApprovalRepository) {}

  async execute(params?: GetApprovalsParams): Promise<ApprovalsResultEntity> {
    return await this.repository.getApprovals(params);
  }
}
